/** @var translates **/
/** @global discount **/
document.addEventListener('alpine:init', () => {
    Alpine.data('app_discount', () => ({
        init: function () {
            const _this = this;

            this.fetchModelsFromApi(this.discount.discountable_ids, this.discount.discountables);
            this.fetchModelsFromApi(this.discount.buy_item_ids, this.discount.buy_items);
            this.fetchModelsFromApi(this.discount.get_item_ids, this.discount.get_items);
            this.fetchModelsFromApi(this.discount.location_ids, this.discount.locations);
        },
        modalTitle: '',
        search_target: null, // products || categories || locations
        search_term: '',
        search_results: {
            products: [],
            categories: [],
            locations: [],
        },
        search_loading: true,
        search_current_page: 1,
        modal_ids: null,
        modal_models: null,
        discount: discount,

        pagination: {
            current_page: 1,
            last_page: 1,
        },

        fetchModelsFromApi: async function (ids, models){
            for (const key in ids) {
                if (ids[key].length){
                    const url = routes.discount.relations.replace('type', key);
                    const request = await fetch(
                        url,
                        {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                "Content-Type": "application/json",
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                            },
                            body: JSON.stringify({ids: ids[key]})
                        },
                    );

                    const data = await request.json();

                    models[key] = data;
                }
            }
        },

        fetchAffectedModels: function (ids, models, type, id) {
            if (ids[type].includes(id.toString())){

                models[type].push(
                    this.search_results[type].filter(function (result) {
                        return result.id == id
                    })[0]
                );
            }else{

                models[type].every(function(item, index){
                    if (item.id == id){
                        models[type].splice(index, 1);

                        return false;
                    }

                    return true;
                })

            }
        },

        fetchAffectedLocations: function (ids, models, type, id) {
            if (ids[type].includes(id.toString())){

                models[type].push(
                    this.search_results['locations'].filter(function (result) {
                        return result.id == id && result.type === type
                    })[0]
                );
            }else{

                models[type].every(function(item, index){
                    if (item.id == id){
                        models[type].splice(index, 1);

                        return false;
                    }

                    return true;
                });

            }
        },

        remove: function(ids, models, type, id){
            ids[type].splice(
                ids[type].indexOf(id.toString()),
                1
            );

            this.fetchAffectedModels(ids, models, type, id);
        },

        fetchSearchResults: async function (page = 1) {
            let url;

            this.search_loading = true;
            this.search_current_page = page;

            const params = new URLSearchParams({
                search: this.search_term,
                paginate_by: '20',
                page: page.toString(),
            });

            switch (this.search_target){
                case 'products':
                    url = routes.products;
                    this.modalTitle = translates.product_selection;
                    document.querySelector('#productCategoryPickerModal').showModal();
                    break;
                case 'categories':
                    url = routes.categories;
                    this.modalTitle = translates.category_selection;
                    document.querySelector('#productCategoryPickerModal').showModal();
                    break;
                case 'locations':
                    url = routes.discount.locations;
                    this.modalTitle = translates.location_selection;
                    document.querySelector('#shippingLocationPickerModal').showModal();
                    break;
            }

            const request = await fetch(
                `${url}?${params.toString()}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    }
                }
            );

            const data = await request.json();

            if(typeof data[this.search_target].data === 'object'){

                this.search_results[this.search_target] = data[this.search_target].data;

                this.pagination.current_page = data[this.search_target].current_page;
                this.pagination.last_page = data[this.search_target].last_page;

            }else{
                this.search_results[this.search_target] = this.flattenArray(data[this.search_target]);
            }

            this.search_loading = false;
        },

        modal: function (ids, models, search_target) {
            this.search_target = search_target;
            this.modal_ids = ids;
            this.modal_models = models;
            this.fetchSearchResults();
        },

        couponCodeGenerator: function (length = 10) {
            const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let couponCode = '';

            for (let i = 0; i < length; i++) {
                const randomIndex = Math.floor(Math.random() * charset.length);
                couponCode += charset[randomIndex];
            }

            this.discount.code = couponCode;
        },

        flattenArray: function (data) {
            const result = [];

            function processItem(item) {
                result.push(item); // Add the item name
                if (item.sub_categories) {
                    item.sub_categories.forEach(child => processItem(child));
                }
                if (item.cities) {
                    item.cities.forEach(child => processItem(child));
                }
            }

            data.forEach(item => processItem(item));

            return result;
        },

        getTranslatedAttribute: function(attribute){
            if (typeof attribute === 'string'){
                return attribute;
            }

            for (const attributeElement in attribute) {
                if (attribute[attributeElement] !== null){
                    return attribute[attributeElement];
                }
            }
        },
    }));
});
// const app_discount = () => ();

var datePickers = $('#available_from, #available_until');
datePickers.daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    minYear: moment().format('YYYY'),
    maxYear: parseInt(moment().add(2,'y').format('YYYY'), 10),
    locale: {
        format: 'DD/MM/YYYY HH:mm:ss',
        cancelLabel: translates.clear,
        "applyLabel": translates.apply,
        "fromLabel": "",
        "toLabel": "",
        "customRangeLabel": translates.custom,
        "weekLabel": translates.calendar.short_week,
        "daysOfWeek": translates.calendar.short_days_of_week,
        "monthNames": translates.calendar.month_names,
        "firstDay": 1
    },
    autoUpdateInput: false,
    drops: 'up'
});

datePickers.on('cancel.daterangepicker', function (ev, picker) {
    var id = picker.element.attr("id"),
        input = $('[name="' + id + '"]');

    picker.element.val("");

    input.val("");
});

datePickers.on('apply.daterangepicker', function (ev, picker) {
    var id = picker.element.attr("id"),
        input = $('[name="' + id + '"]');

    picker.element.val(picker.startDate.format('DD/MM/YYYY HH:mm:ss'));

    input.val(picker.startDate.format('YYYY-MM-DD HH:mm:ss'));
});
